exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group label[data-v-b4ebf45a]{font-size:1.5rem}", ""]);

// exports
